import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Field } from 'redux-form'
import fieldId from 'constants/layout/fieldId'
import {
  required,
  minLength,
} from 'utils/validation'
import styles from './input-password.styl'
const PWD_LENGTH = 12
const errKeys = ['minLength']
const errMess = {
  minLength: {
    text: 'At least {length} characters long',
    intlKey: 'errors.at_least_num_characters',
    values: { length: PWD_LENGTH }
  }
}

class InputPassword extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onInputChange: PropTypes.func,
    label: PropTypes.string.isRequired,
    intlKey: PropTypes.string,
    name: PropTypes.string.isRequired
  }

  validate = value => {
    const { disabled } = this.props

    if (disabled) {
      return {}
    }

    const errors = {}

    const minLengthValue = Boolean(
      required(value) || minLength(PWD_LENGTH)(value)
    )

    if (minLengthValue) {
      errors.minLength = minLengthValue
    }

    return Object.keys(errors).length > 0 ? errors : undefined
  }

  handleChange = (e, field) => {
    if (this.props.onInputChange) {
      this.props.onInputChange(e.target.value)
    }
    field.input.onChange(e.target.value)
  }

  renderField = field => {
    const { disabled } = this.props
    const { meta, input } = field

    const isError =
      meta.touched &&
      meta.error &&
      Object.keys(meta.error).find(item => meta.error[item])
    const classNames = ['form-control']

    isError && classNames.push('error')

    return (
      <div className={disabled ? styles.disabled : ''}>
        <input
          className={classNames.join(' ')}
          {...input}
          type="password"
          disabled={disabled}
          onChange={e => this.handleChange(e, field)}
        />
        {meta.visited &&
          <ul className={styles.errors}>
            {errKeys.map(item => {
              const message = errMess[item]

              return (
                <li
                  key={item}
                  className={
                    get(meta, `error.${item}`)
                      ? styles.messageErr
                      : styles.messageValid
                  }
                >
                  {message && message.intlKey
                    ? <FormattedMessage
                        id={message.intlKey}
                        defaultMessage={
                          typeof message.text === 'string' ? message.text : ''
                        }
                        values={message.values}
                    />
                    : get(message, 'text')}
                </li>
              )
            })}
          </ul>}
      </div>
    )
  }

  render() {
    const { label, name, intlKey } = this.props

    return (
      <div className="form-group" id={`${fieldId}.${name}`}>
        <label htmlFor={name} className="control-label">
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>
        <Field
          id={name}
          name={name}
          component={this.renderField}
          validate={this.validate}
        />
      </div>
    )
  }
}

export default InputPassword